module.exports = __webpack_public_path__ + "src/assets/img/HeadsTails.6684ba02.png";